module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/6TlvBk/tc-custom/9781488065965.jpg?1705766093564",
      "alt": "This image is the cover for the book Confessions of the Duke of Newlyn, The Cornish Dukes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Confessions of the Duke of Newlyn, The Cornish Dukes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("He’s seeking vengeance…  But might find something else entirely  Knowing his best friend, Marianne Treleven, awaits his presence in a Mayfair ballroom, Vennor, the Duke of Newlyn, must hide his secret—he moonlights as a vigilante in pursuit of his parents’ murderer! But when Marianne’s journalistic ambition draws her into the vigilante’s dangerous world, Vennor realizes his closest friend is no longer the innocent miss from Cornwall. She’s a brave, daring, sensual woman he’s desperate to protect at all costs…")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bronwyn Scott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bronwyn Scott is the author of over 50 books. Her 2018 novella, \"Dancing with the Duke's Heir\" was a RITA finalist. She loves history and is always looking forward to the next story. She also enjoys talking with other writers and readers about books they like and the writing process. Readers can visit her at her Facebook page at Bronwynwrites and at her blog at http://www.bronwynswriting.blogspot.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0